import { alpha } from "@mui/material/styles";
const COLORS = [
    "primary",
    "secondary",
    "tertiary",
    "info",
    "success",
    "warning",
    "error",
];
export default function IconButton(theme) {
    const rootStyles = (ownerState) => {
        const defaultStyles = {};
        // Color styles
        const colorStyles = COLORS.reduce((acc, color) => {
            if (ownerState.color === color) {
                const mainColor = color === "tertiary"
                    ? theme.palette.tertiary[40]
                    : theme.palette[color].main;
                if (!mainColor)
                    return acc;
                return Object.assign(Object.assign({}, acc), { color: mainColor, "&:hover": {
                        backgroundColor: alpha(mainColor, 0.08),
                    }, "&:active": {
                        backgroundColor: alpha(mainColor, 0.12),
                    } });
            }
            return acc;
        }, {});
        return [defaultStyles, colorStyles];
    };
    return {
        MuiIconButton: {
            styleOverrides: {
                root: ({ ownerState }) => rootStyles(ownerState),
                sizeLarge: {
                    width: "48px",
                    height: "48px",
                    fontSize: "32px",
                    borderRadius: "500px",
                },
                sizeMedium: {
                    width: "40px",
                    height: "40px",
                    borderRadius: "500px",
                },
                sizeSmall: {
                    width: "36px",
                    height: "36px",
                    fontSize: "20px",
                    borderRadius: "500px",
                },
                sizeXs: {
                    width: "32px",
                    height: "32px",
                    borderRadius: "500px",
                },
            },
        },
    };
}
